export enum HiringOutcome {
    NotYetAnswered = 0,
    Pending = 1,
    Hired = 2,
    NotHired = 3,

  }
  